import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const PossessivesExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Possessive Adjectives & Pronouns (my, mine)</h2>

      <p>
        We use possessive adjectives to show that something belongs to someone. We use possessive pronouns to replace a noun and show possession.
      </p>

      <div className="grammar-explanation-grid">
        <div className="example-block">
          <h3><FaLightbulb /> Possessive Adjectives</h3>
          <p>Come before a noun.</p>
          <ul>
            <li><strong>I</strong> → <strong>my</strong> (my book)</li>
            <li><strong>you</strong> → <strong>your</strong> (your car)</li>
            <li><strong>he</strong> → <strong>his</strong> (his house)</li>
            <li><strong>she</strong> → <strong>her</strong> (her bag)</li>
            <li><strong>it</strong> → <strong>its</strong> (its tail)</li>
            <li><strong>we</strong> → <strong>our</strong> (our friends)</li>
            <li><strong>they</strong> → <strong>their</strong> (their dog)</li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Possessive Pronouns</h3>
          <p>Replace a noun. They do NOT come before a noun.</p>
          <ul>
            <li><strong>I</strong> → <strong>mine</strong> (This book is mine.)</li>
            <li><strong>you</strong> → <strong>yours</strong> (That car is yours.)</li>
            <li><strong>he</strong> → <strong>his</strong> (That house is his.)</li>
            <li><strong>she</strong> → <strong>hers</strong> (This bag is hers.)</li>
            <li><strong>it</strong> → <strong>its</strong> (Not commonly used as pronoun)</li>
            <li><strong>we</strong> → <strong>ours</strong> (These friends are ours.)</li>
            <li><strong>they</strong> → <strong>theirs</strong> (That dog is theirs.)</li>
          </ul>
        </div>

        <div className="grammar-flex-table">
          {[
            [
              'Subject', 'Possessive Adjective', 'Possessive Pronoun',
              'I', 'my', 'mine',
              'you', 'your', 'yours',
              'he', 'his', 'his',
              'she', 'her', 'hers',
              'it', 'its', '(rare)',
              'we', 'our', 'ours',
              'they', 'their', 'theirs',
            ]
          ].map((row, index) => (
            <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
              {row.map((cell, i) => (
                <div key={i} className="grammar-cell">{cell}</div>
              ))}
            </div>
          ))}
        </div>

        <div className="grammar-explanation-text">
          <h3><FaLightbulb /> Key Differences</h3>
          <ul>
            <li><strong>Adjective</strong> + noun: <em>my car</em>, <em>her phone</em></li>
            <li><strong>Pronoun</strong> alone (replaces noun): <em>This is mine.</em>, <em>Is this yours?</em></li>
            <li>Compare: <em>That's her bag.</em> (adjective + noun) vs <em>That bag is hers.</em> (pronoun)</li>
            <li><strong>his</strong> is the same for adjective and pronoun: <em>his book</em> / <em>The book is his.</em></li>
          </ul>
          <p><strong>Examples:</strong></p>
          <ul>
            <li>This is <strong>my</strong> house. → The house is <strong>mine</strong>.</li>
            <li>Is that <strong>your</strong> phone? → Is that phone <strong>yours</strong>?</li>
            <li>They are <strong>our</strong> friends. → Those friends are <strong>ours</strong>.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PossessivesExplanation;